import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ProjectService } from 'src/app/services/project.service';
import { AssignProjectMemberComponent } from 'src/app/shared/components/assign-project-member/assign-project-member.component';

@Component({
    selector: 'app-project-team',
    templateUrl: './project-team.component.html',
    styleUrl: './project-team.component.scss',
    standalone: false
})
export class ProjectTeamComponent implements OnInit {

	@ViewChild('assignProjectMember') assignProjectMemberModal!: AssignProjectMemberComponent;
	@Input() currentProject!: any;

	users: any[] = [];
  currentPage: number = 1;
  pageSize: number = 8;
  totalUsers: number = 0;
  searchText: string = '';
  sortColumn: string = 'createdAt';
  sortDirection: string = 'desc';

	startIndex: number = 0;
  endIndex: number = 0;

	currentUser: any = null;
	current_client: any = null;
	loading = true;
	isOwner = false;
	canAssign = true;

	private searchSubject = new Subject<string>();

	constructor(private projectService: ProjectService, private authService: AuthService) {}

	ngOnInit(): void {
		this.currentUser = this.authService.currentUserValue;
		this.current_client = this.authService.currentClientValue;
		if (this.currentProject.parent_project_id !== null && this.authService.currentClientValue.roles.includes('ADMIN')) {
			this.canAssign = false;
		}
		this.isOwner = this.authService.currentClientValue.roles.includes('OWNER');
		this.getUsers();

    // Subscribe to search input changes with debounce
    this.searchSubject.pipe(
      debounceTime(300), // Adjust debounce time as needed
      distinctUntilChanged()
    ).subscribe(() => {
      this.currentPage = 1; // Reset to first page when search text changes
      this.getUsers();
    });
	}

	getUsers() {
		this.loading = true;
    const params = {
      page: this.currentPage.toString(),
      pageSize: this.pageSize.toString(),
      searchText: this.searchText,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };

		this.projectService.getProjectMembers(this.currentProject.id, params).subscribe({
			next: (response: any) => {
				this.users = response.users;
				this.totalUsers = response.totalUsers;
				this.calculateIndexes();
				this.loading = false;
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Project members');
			}
		});
  }

	refreshUsers() {
		this.currentPage = 1;
		this.searchText = '';
		this.getUsers();
	}

	onPageChange(page: number) {
    this.currentPage = page;
    this.getUsers();
  }

  onSearch() {
    this.searchSubject.next(this.searchText);
  }

  onSort(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.getUsers();
  }

	calculateIndexes() {
    this.startIndex = (this.currentPage - 1) * this.pageSize + 1;
    this.endIndex = Math.min(this.currentPage * this.pageSize, this.totalUsers);
  }

	openModal(mode: string, user?: any) {
		switch (mode) {
			case 'remove':
				this.assignProjectMemberModal.openRemoveModal(user);
				break;
			case 'assign':
				this.assignProjectMemberModal.openModal(true);
				break;
		}
	}
}
